export const apiUrl = {
    ACM_POST_GET_TOKEN: "/account/get_token",
    ACM_POST_REFRESH_TOKEN: "/account/refresh_token",
    JM_GET_SKILLS: "/job/get_skills_field",
    JM_POST_ADD_JOB: "/job/add_job",
    JM_POST_EDIT_JOB: "/job/edit_job",
    JM_GET_JOB_DETAILS: "/job/jobdetails",
    JM_GET_JOB_FIELDS: "/job/get_jobfield",
    JM_GET_JOBS: "/job/get_jobs",
    JM_POST_ADD_OR_UPDATE_UPLOAD_TRACKER: "/job/upload-tracker",
    JM_POST_UPLOAD_RESUMES_TO_OCR: "/job/upload_resumes_to_ocr",
    JM_GET_GET_MARKET_JOBDATA: "/job/get_market_jobdata",
    JM_POST_POST_MARKET_JOBDATA: "/job/post_market_jobdata",
    JM_GET_UPTODATE_MARKET_JOBDATA: "job/get_uptodate_market_jobdata",
    JM_GET_CANDIDATES: "/job/get_candidates",
    JM_GET_CANDIDATE_NOTES: "/job/get_candidate_notes",
    JM_POST_ADD_CANDIDATE_NOTE: "/job/add_candidate_note",
    JM_POST_DELETE_CANDIATE: "/job/delete_candidate",
    JM_POST_SEND_NOTIFY: "/job/send_notify",
    JM_POST_DELETE_JOB: "/job/delete_job",
    UM_GET_GET_USERS: "/user/get_users",
    UM_POST_DELETE_USER: "/user/delete_user",
    UM_POST_EDIT_USER: "/user/edit_user",
    UM_POST_EDIT_USER_IMAGE: "/user/edit_user_image",
    UM_POST_ADD_USER: "/user/add_user",
    UM_POST_ADD_USER_IMAGE: "/user/add_user_image",
    UM_POST_CHECK_USERID_EXISTS: "/user/check_userid_exists",
    UM_GET_USER: "/user/get_user",
    JM_GET_HIRING_FLOW: "/job/get_hiringflow",
    UM_POST_EDIT_USER_BY_USER: "/user/edit_user_by_user",
    UM_POST_CHANGE_PASSWORD_BY_AUTH: "/user/change_password_by_authorizedUser",
    CM_GET_EMAIL_TEMPLATES: "/communication/get-email-templates",
    CM_POST_ADD_EMAIL_TEMPLATE: "/communication/add-email-templates",
    CM_POST_DELETE_EMAIL_TEMPLATE: "/communication/delete-email-templates",
    CM_GET_DASHBOARD_MESSAGES: "/communication/get-dashboard-messages",
    CM_POST_ADD_DASHBOARD_MESSAGE: "/communication/add-dashboard-messages",
    CM_POST_DELETE_DASHBOARD_MESSAGE: "/communication/delete-dashboard-messages",
    CM_POST_SEND_MULTIPLE_EMAILS: "/communication/send-multiple-emails",
    CM_POST_SEND_DASHBOARD_MESSAGES: "/communication/send-dashboard-messages",
    UM_POST_RESET_PASSWORD: "/user/reset_password",
    UM_POST_CHANGE_PASSWORD: "/user/change_password",
    UM_POST_VALIDATE_SECRET_KEY: "/user/validate_secret_key",
    JM_GET_FORM_DROPDOWNS: "/job/form-dropdowns",
    JM_GET_GENERATED_JOB_POSTING_ID: "/job/generate_job_posting_id",
    JM_POST_UPLOAD_JOB_LOGO: "/job/upload_job_logo",
    JM_POST_DOWNLOAD_RESUME: "/job/download_candidate_resume",
    JM_GET_CANDIDATE_STATUS_HISTORY: "/job/get_candidate_status_history",
    JM_GET_GENERATE_JOB_DESCRIPTION: "/job/generate_job_description",
    UM_GET_PANEL_AND_STAKEHOLDERS_DROPDOWN: "/user/get_panel_and_stakeholder_dropdown",
    UM_POST_ADD_PANEL_AND_STAKEHOLDER: "/user/add_panel_and_stakeholder",
    UM_GET_PANEL_AND_STAKEHOLDERS: "/user/get_panel_and_stakeholders",
    UM_POST_DELETE_PANEL_OR_STAKEHOLDER: "/user/delete_panel_or_stakeholder",
    JM_GET_HIRING_FLOW_BY_JOB: "/job/get_hiringflow_by_job",
    UM_GET_ALL_PANEL_MEMBERS: "/user/get_all_panel_members",
    UM_POST_SEND_EMAILS_TO_STAKEHOLDERS: "/user/send_emails_to_stakeholders",
    JM_GET_EXPORT_JOB_DATA: "/job/export_job_data",
    JM_GET_CANDIDATE_SUMMARY_BY_JOB: "/job/get_candidate_summary_by_job",
    JM_GET_CANDIDATES_BY_STATUS: "/job/get_candidates_by_status",
    JM_POST_DELETE_JOB_LOGO: "/job/delete_job_logo",
    UM_GET_ALL_USER_NUMS: "/user/get_all_user_nums",
    ACM_GET_HELP_DOC: "/account/help_doc",
    CM_GET_OFFER_LETTER: "/communication/get-offer-letter",
    JM_ADD_PERSONAL_INFO_CUSTOM_FIELD: "/job/add_personal_info_custom_field",
    JM_GET_PERSONAL_INFO_CUSTOM_FIELDS: "/job/get_personal_info_custom_fields",
    JM_DELETE_PERSONAL_INFO_CUSTOM_FIELD: "/job/delete_personal_info_custom_field",
    JM_GET_ONBOARDING_QUESTIONS: "job/get_onboardingquestions",
    JM_POST_SAVE_ONBOARDING_QUESTIONS: "job/save_onboardingquestions",
    JM_POST_DELETE_ONBOARDING_QUESTION: "job/delete_onboardingquestion",
    JM_GET_DOCUMENTS_CUSTOM_FIELDS: "/job/get_documents_custom_fields",
    JM_POST_ADD_DOCUMENTS_CUSTOM_FIELD: "/job/add_documents_custom_field",
    JM_POST_DELETE_DOCUMENT_CUSTOM_FIELD: "/job/delete_documents_custom_field",
    JM_GET_PREBOARDING_SUMMARY: "/job/get_preboarding_status_summary",
    JM_GET_PREBOARDING_CANDIDATES: "/job/get_preboarding_candidates",
    JM_POST_SEND_PREBOARDING_NOTIFICATION: "/job/send_preboarding_notification",
    JM_GET_BGV_PENDING_CANDIDATES: "/job/get_bgv_pending_candidates",
    JM_GET_CANDIDATE_OFFER_LETTER: "/job/get_candidate_offer_letter",
    JM_POST_UPDATE_CADIDATE_OFFER_LETTER: "/job/update_candidate_offer_letter",
    JM_SEND_OTP: "/job/send_otp",
    JM_POST_UPLOAD_CANDIDATE_OFFER_LETTER_FILE: "/job/upload_candidate_offer_letter_file",
    JM_POST_DELETE_CANDIDATE_OFFER_LETTER_FILE: "/job/delete_candidate_offer_letter_file",
    JM_POST_VALIDATE_OTP: "/job/validate_otp",
    JM_GET_CANDIDATE_DATA: "/job/get_candidate_data",
    JM_GET_DOWNLOAD_CANDIDATE_OFFER_LETTER_PDF: "/job/download_candidate_offer_letter_pdf",
    JM_POST_CANDIDATE_OFFER_LETTER_DECLINE: "/job/candidate_offer_letter_decline",
    JM_POST_CANDIDATE_OFFER_LETTER_ACCEPT: "/job/candidate_offer_letter_accept",
    JM_POST_ADD_OR_UPDATE_CANDIDATE_DETAILS: "/job/add_or_update_candidate_details",
    JM_GET_CANDIDATE_CUSTOM_FIELD_VALUES: "/job/get_candidate_custom_field_values",
    JM_POST_DELETE_EMPLOYMENT_HISTORY: "/job/delete_employment_history",
    JM_GET_CANDIDATE_DOCUMENTS: "/job/get_candidate_documents",
    JM_POST_ADD_CANDIDATE_DOCUMENTS: "/job/add_candidate_documents",
    JM_POST_DELETE_CANDIDATE_DOCUMENT: "/job/delete_candidate_document",
    JM_POST_DELETE_EMPLOYMENT_HISTORY_DOCUMENT: "/job/delete_employment_history_document",
    JM_POST_UPDATE_CANDIDATE_EMAIL: "/job/update_candidate_email",
    JM_GET_DOWNLOAD_CANDIDATE_DOCUMENT: "/job/download_candidate_document",
    JM_GET_DOWNLOAD_ALL_CANDIDATE_DOCUMENTS_ZIP: "/job/download_all_candidate_documents_zip",
    JM_POST_VERIFY_CANDIDATE_DOCUMENT: "/job/verify_candidate_document",
    JM_POST_SUBMIT_CANDIDATE_DOCUMENTS: "/job/submit_candidate_documents",
    JM_POST_COMPLETE_CANDIDATE_DOCUMENTS_VERIFICATION: "/job/complete_candidate_documents_verification",
    JM_POST_SAVE_HIRING_EXPERIENCE: "/job/save_hiring_experience",
    JM_POST_COMPLETE_BGV: "/job/complete_bgv",
    JM_POST_NOTIFY_INTERNAL_TEAMS: "/job/notify_internal_teams"
}